import { Semestre } from './semestre';
import { Aquisicao } from '../../../../cliente-carteira/kpis/aquisicao/adapters';
import { CarteiraInativa } from '../../../../cliente-carteira/kpis/carteira-inativa/adapters';
import { Comissao } from '../../../../comissao/kpis/adapters';

/** Dados dos KPIs anual */
export class Ano {
    ano: number;
    semestres: Semestre[];
    aquisicao: Aquisicao;
    carteiraInativa: CarteiraInativa;
    comissao: Comissao;

    constructor(props: Partial<Ano>) {
        Object.assign(this, props);

        if (props) {
            // Semestres
            this.constructorSemestres(props.semestres);
            // Aquisição
            this.aquisicao = props.aquisicao ? new Aquisicao(props.aquisicao) : null;
            // Carteira Inativa
            this.carteiraInativa = props.carteiraInativa ? new CarteiraInativa(props.carteiraInativa) : null;
            // Comissão
            this.comissao = props.comissao ? new Comissao(props.comissao) : null;
        }
    }

    /** Constructor para os semestres */
    private constructorSemestres(semestres: Semestre[]) {
        if (semestres && Array.isArray(semestres)) {
            this.semestres = semestres.map(semestre => new Semestre(semestre));
        } else {
            this.semestres = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Ano {
        return new Ano(JSON.parse(json));
    }
}
